import { gql } from '@apollo/client'

const COMPARISON_TABLE_FIELDS = gql`
  fragment ComparisonTableFields on ComparisonTableType {
    id
    createdAt
    updatedAt
    deletedAt
    version
    title
    description
    boosterPremiumPrice
    bootcampProPrice
    features
    disclaimerDescription
  }
`

export const UPDATE_COMPARISON_TABLE = gql`
  ${COMPARISON_TABLE_FIELDS}
  mutation UpdateComparisonTable($updateComparisonTableInputFieldName: UpdateComparisonTableInput!) {
    updateComparisonTable(updateComparisonTableInputFieldName: $updateComparisonTableInputFieldName) {
      ...ComparisonTableFields
    }
  }
`

export const FIND_COMPARISON_TABLE = gql`
  ${COMPARISON_TABLE_FIELDS}
  query FindComparisonTable($platformSlug: String!) {
    findComparisonTable(platformSlug: $platformSlug) {
      ...ComparisonTableFields
    }
  }
`
